// extracted by mini-css-extract-plugin
module.exports = {"draggable":"MultiValueContainer_draggable__2MHMf","dragging":"MultiValueContainer_dragging__2gixM"};